module.exports = __webpack_public_path__ + "img/alerus-mobile.ecf01dea.svg";